module.exports = __webpack_public_path__ + "assets/img/btn-back-74e0c029.png";